import React from 'react'
import item1 from "../../Assetes/Images/item-1.png"
import item2 from "../../Assetes/Images/item-2.png"
import item3 from "../../Assetes/Images/item-3.png"
import { IMAGE_URL } from '../../Components/client-config'
import { Link } from 'react-router-dom'
import mergn from 'mergn-webapp-sdk'
import useCurrentLocale from '../../hooks/useLanguage'
import { useTranslation } from 'react-i18next'
import { getSlugFromName } from '../../utils/helpers'

export default function MobileCategories(props: any) {
    const lang = useCurrentLocale();
    const { t } = useTranslation();

    function handleCategoryClick(id: number) {
        sessionStorage.setItem("group_name", props.groups[id].group_name.replace(/\s+/g, ''))
        mergn.recordEvent('Category Click', [
            { eventProperty: 'category-name', value: props.groups[id].group_name }
        ]);
    }

    return (
        <div className='container'>
            {props.groups.length > 0 && <div className='d-flex justify-content-between align-items-center catmob'>
                <h2 className='items-title mb-3'><span>{t("EXPLOREMENU")}</span></h2>
                <div>
                    <Link to={`/menu#${getSlugFromName(props.groups[0].group_name)}`} className='b-view-all'>{t("VIEW_ALL")} </Link>
                </div>
            </div>}
            <div className="row mobile-category-row">
                {props.groups && props.groups.length > 0 ?
                    <>
                        <div className="col-4 pr-0 pl-set">
                            <div className="col-12 h-100">
                                <div onClick={() => handleCategoryClick(0)} className='mobile-brows-box mb-2' style={{ height: "103%" }}>
                                    <h6>{props.groups[0] && props.groups[0].group_name}</h6>
                                    <Link to={`/${lang}/menu#${getSlugFromName(props.groups?.[0].group_name)}`}><img src={`${IMAGE_URL}${props.groups[0] && props.groups[0].group_image}`} alt="" /></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-4 px-1">
                            <div className="col-12 h-50">
                                <div className='mobile-brows-box' onClick={() => handleCategoryClick(1)}>
                                    <h6>{props.groups[1] && props.groups[1].group_name}</h6>
                                    <Link to={`/${lang}/menu#${getSlugFromName(props.groups[0].group_name)}`}><img src={`${IMAGE_URL}${props.groups[1] && props.groups[1].group_image}`} alt="" /></Link>
                                </div>
                            </div>
                            <div className="col-12 mt-1 h-50">
                                <div className='mobile-brows-box' onClick={() => handleCategoryClick(2)}>
                                    <h6>{props.groups[2] && props.groups[2].group_name}</h6>
                                    <Link to={`/${lang}/menu#${getSlugFromName(props.groups[0].group_name)}`}><img src={`${IMAGE_URL}${props.groups[2] && props.groups[2].group_image}`} alt="" /></Link>
                                </div>
                            </div>

                        </div>
                        <div className="col-4 pl-0 pr-set">
                            <div className="col-12 h-50">
                                <div className='mobile-brows-box' onClick={() => handleCategoryClick(3)}>
                                    <h6>{props.groups[3] && props.groups[3].group_name}</h6>
                                    <Link to={`/${lang}/menu#${getSlugFromName(props.groups[0].group_name)}`}><img src={`${IMAGE_URL}${props.groups[3] && props.groups[3].group_image}`} alt="" /></Link>
                                </div>
                            </div>
                            <div className="col-12 mt-1 h-50">
                                <div className='mobile-brows-box' onClick={() => handleCategoryClick(4)}>
                                    <h6>{props.groups[4] && props.groups[4].group_name}</h6>
                                    <Link to={`/${lang}/menu#${getSlugFromName(props.groups[0].group_name)}`}><img src={`${IMAGE_URL}${props.groups[4] && props.groups[4].group_image}`} alt="" /></Link>
                                </div>
                            </div>
                        </div>
                    </>
                    : <div />
                }
            </div>
        </div>
    )
}
